import React, { useState, useRef, useEffect } from 'react';
import { Button, message, Collapse, Input, Checkbox, Upload } from 'antd';
import { RightOutlined } from "@ant-design/icons";
import { getMinSec } from '../../../libs/utils';
import { compressImageFile } from '../../../libs/image';
import BaseColumnInput from '../../../components/input/base_column_input';
import BaseRowInput from '../../../components/input/base_row_input';
import BaseColumnSelect from '../../../components/select/base_column_select';
import BaseDragAndDropUpload from '../../../components/upload/base_dnd_upload';
import BaseClearInput from '../../../components/input/base_clear_input';
import { restApi } from '../../../apis';

const CreateExerciseModal = (props) => {
  const [messageApi, contextHolder] = message.useMessage();
  const { title, restUrl, setGModal, setState, categoryId, ...rest } = props;
  const isRead = false;
  const videoRef = useRef(null);

  const { TextArea } = Input;
  const [data, setData] = useState({
    categoryId: categoryId,
    videoKey: '',
    thumnailKey: '',
    engName: '',
    korName: '',
    isPublic: '',
    tag1: '',
    tag2: '',
    tag3: '',
    time: '', //초
    etc: {
      videoPath: '',
      videoExt: '',
      videoName: '',
      thumbPath: '',
      thumbExt: '',
      thumbName: '',
    },
    actionDescription: '',
    education: '',
    notice: ''
  });

  const tag1Options = [
    '바벨', '덤벨', '케틀벨', '랜드마인', '벤치', '클럽벨', '스텝박스',
    '허들', '폴라이오박스', '불가리안백', '아쿠아백', '바이퍼',
    '매트', '폼롤러', '의자', '미니볼', '메디신볼', '짐볼', '보수',
    '밴드', '리커버링', '스틱모빌리티', 'S.M보드',
    '리포머', '바렐', '스파인코렉터', '체어', '케딜락',
    '서스펜션 트레이너(TRX)', '프리폼보드', '코어케이블', '파워플레이트', '마사지건'
  ];
  const tag2Options = [
    '목', '가슴', '어깨', '윗 팔(상완)', '아래팔(전완)', '등 허리', '복부',
    '엉덩이 골반', '허벅지', '종아리', '손목', '발목'
  ];
  const tag3Options = [
    '선 자세', '런지 자세', '스쿼트 자세',
    '바닥에 앉은 자세', '무릎 꿇은 자세', '반 무릎 자세', '의자에 앉은 자세',
    '등을 대고 누운 자세', '엎드려 누운 자세', '옆으로 누운 자세',
    '앞으로 플랭크 자세', '뒤로 플랭크 자세', '옆으로 플랭크 자세'
  ];

  const [tag1, setTag1] = useState([]);
  const [tag2, setTag2] = useState([]);
  const [tag3, setTag3] = useState([]);
  
  // 체크박스 그룹 컴포넌트(재사용)
  const TagCheckbox = ({ tag, selectedTags, setSelectedTags }) => (
    <Checkbox
      checked={selectedTags.includes(tag)}
      onChange={e => {
        if (e.target.checked) setSelectedTags([...selectedTags, tag]);
        else setSelectedTags(selectedTags.filter(v => v !== tag));
      }}
      style={{ margin: 0 }}
      value={tag}
    >
      {tag}
    </Checkbox>
  );
  
  // useState로 selectedTag 관리


  
  const playerRef = React.useRef(null);
  useEffect(() => {
    if (videoRef.current) {
      const handleLoadedMetadata = () => {
        setData(prev => ({
          ...prev,
          time: Math.round(videoRef.current.duration) + ''
        }));
      };
      videoRef.current.addEventListener('loadedmetadata', handleLoadedMetadata);
      return () => {
        if (videoRef.current) {
          videoRef.current.removeEventListener('loadedmetadata', handleLoadedMetadata);
        }
      };
    }
  }, [data.etc.videoName, data.etc.videoPath, data.videoKey]);
  const { Panel } = Collapse;
  const korNameRegex = /^[0-9A-Za-z가-힣ㄱ-ㅎㅏ-ㅣ ()]*$/;
  const isValidKorName = (value) => korNameRegex.test(value);
  const normalizeWhitespace = (value) =>
    String(value || '').normalize('NFKC').replace(/\s+/g, ' ').trim();
  const sanitizeKorName = (value) =>
    normalizeWhitespace(value).replace(/[^0-9A-Za-z가-힣ㄱ-ㅎㅏ-ㅣ ()]/g, '');
  const getInvalidChars = (value) => {
    const chars = [];
    for (const ch of String(value || '')) {
      if (!korNameRegex.test(ch)) {
        chars.push(ch);
      }
    }
    return [...new Set(chars)];
  };
  const formatInvalidChars = (chars) =>
    chars
      .map((ch) => {
        const code = ch.codePointAt(0).toString(16).toUpperCase().padStart(4, '0');
        const printable =
          ch === ' ' ? '[space]' : /\s/.test(ch) ? '[whitespace]' : ch;
        return `${printable}(U+${code})`;
      })
      .join(', ');
  const extractNamesFromFilename = (fileName) => {
    const baseName = normalizeWhitespace(
      String(fileName || '').replace(/\.[^.]+$/, '')
    );
    if (!baseName) return { kor: '', eng: '' };

    const tokens = baseName.split(/\s+/).filter(Boolean);
    const firstEnglishIdx = tokens.findIndex((token) => /[A-Za-z]/.test(token));
    if (firstEnglishIdx === -1) {
      return { kor: baseName, eng: '' };
    }

    const kor = tokens.slice(0, firstEnglishIdx).join(' ').trim();
    const eng = tokens.slice(firstEnglishIdx).join(' ').trim();
    return { kor, eng };
  };

  const handleThumbBeforeUpload = async (file) => {
    const isImage = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isImage) {
      messageApi.error('JPG/PNG 이미지 파일만 업로드 가능합니다.');
      return Upload.LIST_IGNORE;
    }

    try {
      const compressed = await compressImageFile(file, {
        maxWidth: 1280,
        maxHeight: 1280,
        quality: 0.8,
        maxSizeMB: 1,
      });
      return compressed;
    } catch (err) {
      console.error('[thumb-compress-error]', err);
      return file;
    }
  };

  return (
    <div style={{ ...styles.container }}>
      {contextHolder}
      <div style={{ ...styles.header }}>{title}</div>
      <div style={{ ...styles.row, marginTop: '2.4rem' }}>
        <div style={{ ...styles.column, width: '52.6rem' }}>
          <BaseColumnInput
            label={`운동 영문명`}
            labelStyle={{
              ...styles.label,
            }}
            value={data.engName}
            readonly={isRead}
            onChange={(e) => {
              setData((prev) => {
                return {
                  ...prev,
                  engName: String(e.target.value || '').trim(),
                };
              });
            }}
          />
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'flex-start',
            }}
          >{`운동영상에 알맞는 영문 운동명을 입력해 주세요.`}</div>
        </div>
        <div style={{ ...styles.column, width: '52.6rem' }}>
          <BaseColumnInput
            label={`운동 국문명`}
            labelStyle={{
              ...styles.label,
            }}
            value={data.korName}
            readonly={isRead}
            onChange={(e) => {
              const nextValue = String(e.target.value || '');
              if (!isValidKorName(nextValue)) {
                messageApi.error('특수문자는 사용할 수 없습니다.');
                return;
              }
              setData((prev) => ({
                ...prev,
                korName: nextValue,
              }));
            }}
          />
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'flex-start',
            }}
          >{`운동영상에 알맞는 국문 운동명을 입력해 주세요.`}</div>
        </div>
      </div>
      <div style={{ ...styles.row, marginTop: '2.4rem' }}>
        <div
          style={{
            width: '100%',
            border: '0.5px solid #F0F0F0',
          }}
        />
      </div>
      <div style={{ ...styles.row, marginTop: '2.4rem' }}>
      <Collapse style={{ width: '100%' }} expandIcon={({ isActive }) => (<RightOutlined rotate={isActive ? 90 : 0} />)}>
        <Panel header="#운동 동작 태그" key="1" >
          <div>
            <div style={{marginBottom: 8, fontWeight: 600}}>도구별</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              {tag1Options.map(tag => (
                <TagCheckbox key={tag} tag={tag} selectedTags={tag1} setSelectedTags={setTag1} />
              ))}
            </div>
            <div style={{margin: "16px 0 8px", fontWeight: 600}}>신체부위별</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              {tag2Options.map(tag => (
                <TagCheckbox key={tag} tag={tag} selectedTags={tag2} setSelectedTags={setTag2} />
              ))}
            </div>
            <div style={{margin: "16px 0 8px", fontWeight: 600}}>포지션별</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              {tag3Options.map(tag => (
                <TagCheckbox key={tag} tag={tag} selectedTags={tag3} setSelectedTags={setTag3} />
              ))}
            </div>
          </div>
        </Panel>
      </Collapse>
      </div>
      <div style={{ ...styles.row, marginTop: '2.4rem' }}>
        <div
          style={{
            width: '100%',
            border: '0.5px solid #F0F0F0',
          }}
        />
      </div>
      <div style={{ ...styles.row, marginTop: '2.4rem' }}>
        <div
          style={{
            ...styles.column,
            width: '33.2rem',
            height: '40.5rem',
            alignItems: 'flex-start',
          }}
        >
          <BaseDragAndDropUpload
            width={332}
            height={185}
            contentComponent={() => (
              <>
                <div style={{ ...styles.upload_title }}>
                  {`동영상 파일을 드래그 앤 드롭`}
                  <br />
                  {`또는 위 아이콘을 클릭하여`}
                  <br />
                  {`영상파일 선택 후 업로드`}
                </div>
                <div style={{ ...styles.upload_hint, marginTop: 20 }}>
                  {` 1288 X 1080`}
                  <br />
                  {`영상 업로드 후 우측화면에서 미리보기 가능)`}
                </div>
              </>
            )}
            setUploadFile={(args) => {
              if (args?.response?.payload) {
                const fileName = args.name || '';
                const keyId = args.response.payload.files[0].id || '';
                const videoPath = args.response.payload.files[0].path || '';
                const videoExt = args.response.payload.files[0].ext || 'mp4';

                setData((prev) => {
                  return {
                    ...prev,
                    videoKey: keyId,
                    etc: {
                      ...prev.etc,
                      videoPath: videoPath,
                      videoExt: videoExt,
                      videoName: fileName,
                    },
                  };
                });
              }
            }}
          />
          <div style={{ marginTop: '2rem' }} />
          <BaseDragAndDropUpload
            width={332}
            height={140}
            accept="image/png,image/jpeg"
            beforeUpload={handleThumbBeforeUpload}
            contentComponent={() => (
              <div style={{ ...styles.upload_title }}>
                {`썸네일이미지를 드래그 앤 드롭`}
                <br />
                {`또는 위 아이콘을 클릭하여`}
                <br />
                {`이미지 파일 선택 후 업로드`}
              </div>
            )}
            setUploadFile={(args) => {
              if (args?.response?.payload) {
                const fileName = args.name || '';
                const keyId = args.response.payload.files[0].id || '';
                const thumbPath = args.response.payload.files[0].path || '';
                const thumbExt = args.response.payload.files[0].ext || 'mp4';
                const { kor, eng } = extractNamesFromFilename(fileName);
                const sanitizedKor = sanitizeKorName(kor);
                const normalizedEng = normalizeWhitespace(eng);

                setData((prev) => {
                  return {
                    ...prev,
                    thumnailKey: keyId,
                    etc: {
                      ...prev.etc,
                      thumbPath: thumbPath,
                      thumbExt: thumbExt,
                      thumbName: fileName,
                    },
                    korName: prev.korName ? prev.korName : sanitizedKor,
                    engName: prev.engName ? prev.engName : normalizedEng,
                  };
                });
              }
            }}
          />

          <div style={{ ...styles.timeBox, marginTop: '2rem' }}>
            <BaseRowInput
              height={'3.8rem'}
              label={`운동 영상 시간 입력 (초)`}
              labelStyle={{
                fontWeight: 600,
                fontSize: '1.2rem',
                lineHeight: '1.7rem',
              }}
              readonly={isRead}
              value={data?.time}
              onChange={(e) => {
                setData((prev) => {
                  return {
                    ...prev,
                    time:
                      String(e.target.value || '').length > 4
                        ? data?.time
                        : e.target.value,
                  };
                });
              }}
            />
          </div>
        </div>
        <div style={{ ...styles.videoBox }}>
          {String(data.etc.videoName || '').length > 0 ||
          String(data.etc.thumbName || '').length > 0 ? (
            <video
              ref={videoRef}
              id="my-video"
              className="video-js"
              controls
              preload="auto"
              width="720"
              height="400"
              src={`https://cdn.humanb.kr/${data?.etc?.videoPath}/${data?.videoKey}.${data?.etc?.videoExt}`}
              poster={`https://cdn.humanb.kr/${data?.etc?.thumbPath}/${data?.thumnailKey}.${data?.etc?.thumbExt}`}
            ></video>
          ) : (
            <img
              width={108}
              height={74}
              src={require('../../../assets/images/ico_novideo.png')}
            />
          )}
        </div>
      </div>
      <div style={{ ...styles.row, marginTop: 24 }}>
        <BaseClearInput
          width={'33rem'}
          label={`업로드된 영상파일`}
          labelStyle={{
            ...styles.label,
          }}
          readonly={isRead}
          onClick={() => {
            setData((prev) => ({
              ...prev,
              videoKey: '',
              etc: { ...prev.etc, videoName: '', videoPath: '', videoExt: '' },
            }));
          }}
          textValue={
            data.etc.videoName.length > 0
              ? data.etc.videoName
              : '영상파일을 선택해 주세요'
          }
        />
        <BaseClearInput
          width={'33rem'}
          label={`운동 영상 썸네일`}
          labelStyle={{
            ...styles.label,
          }}
          readonly={isRead}
          onClick={(e) => {
            setData((prev) => ({
              ...prev,
              thumnailKey: '',
              etc: { ...prev.etc, thumbName: '', thumbPath: '', thumbExt: '' },
            }));
          }}
          textValue={
            data.etc.thumbName.length > 0
              ? data.etc.thumbName
              : '썸네일이미지을 선택해 주세요'
          }
        />
        <BaseClearInput
          width={'33rem'}
          label={`운동 영상 시간 입력`}
          labelStyle={{
            ...styles.label,
          }}
          onClick={(e) => {
            setData((prev) => ({
              ...prev,
              time: '',    // ← 아예 빈 값으로 clear!
            }));
          }}
          readonly={isRead}
          textValue={
            data?.time.length > 0
              ? getMinSec(data?.time)
              : '00:00 운동 영상 시간을 입력해 주세요'
          }
        />
      </div>
      <div
        style={{
          ...styles.row,
          height: '2.2rem',
          fontWeight: 400,
          fontSize: '1.2rem',
          lineHeight: '1.5rem',
        }}
      >
        {`업로드된 영상명과 확장자 표시(위 드래그 앤 드롭 또는 아이콘 클릭 후 영상파일을 재선택하면 기존 업로드된 영상은 삭제되고 새로 업로드한 영상으로 변경), 우측 X표시 아이콘 클릭 시 업로드 파일 제거`}
      </div>
      <div style={{ ...styles.row, marginTop: '2.4rem' }}>
        <div
          style={{
            width: '100%',
            border: '0.5px solid #F0F0F0',
          }}
        />
        </div>
        <div style={{ ...styles.row2, marginTop: 24 }}>
          {'동작 설명'}
          <TextArea
            onChange={(e) => {
              setData((prev) => {
                return {
                  ...prev,
                  actionDescription: String(e.target.value || '').trim(),
                };
              });
            }}
            value={data?.actionDescription}
          />
        </div>
        <div style={{ ...styles.row2, marginTop: 24 }}>
          {'교육 방법'}
          <TextArea
            onChange={(e) => {
              setData((prev) => {
                return {
                  ...prev,
                  education: String(e.target.value || '').trim(),
                };
              });
            }}
            value={data?.education}
          />
        </div>
        <div style={{ ...styles.row2, marginTop: 24 }}>
          {'유의사항'}
          <TextArea
            onChange={(e) => {
              setData((prev) => {
                return {
                  ...prev,
                  notice: String(e.target.value || '').trim(),
                };
              });
            }}
            value={data?.notice}
          />
      </div>
      <div style={{ ...styles.footer }}>
        <Button
          width={69}
          height={38}
          style={{
            fontWeight: 500,
            fontSize: '1.5rem',
            lineHeight: '1.8rem',
            letterSpacing: 0.43,
          }}
          onClick={(e) => {
            setGModal((prev) => {
              return {
                ...prev,
                show: false,
              };
            });
          }}
        >
          {'취소'}
        </Button>
        <Button
          width={69}
          height={38}
          style={{
            marginLeft: '1rem',
            background: '#A8AAAE',
            boxShadow: '0px 2px 4px rgba(165, 163, 174, 0.3)',
            borderRadius: '0.6rem',
            fontWeight: 500,
            fontSize: '1.5rem',
            lineHeight: '1.8rem',
            letterSpacing: 0.43,
            color: '#FFFFFF',
          }}
          onClick={async (e) => {
            try {
              const korNameValue = String(data?.korName || '');
              if (!korNameValue.trim()) {
                messageApi.error('운동 국문명을 입력해 주세요.');
                return;
              }
              const invalidChars = getInvalidChars(korNameValue);
              if (invalidChars.length > 0) {
                messageApi.error(
                  `국문명에 허용되지 않는 문자가 있습니다: ${formatInvalidChars(
                    invalidChars
                  )}`
                );
                return;
              }
              const res = await restApi.post('/admin/exercise', {
                categoryId: data?.categoryId,
                videoKey: data?.videoKey,
                thumnailKey: data?.thumnailKey,
                engName: data?.engName,
                korName: data?.korName,
                isPublic: data?.isPublic || 'Y',
                time: data?.time,
                tag1: tag1.join(','),
                tag2: tag2.join(','),
                tag3: tag3.join(','),
                actionDescription: data?.actionDescription,
                education: data?.education,
                notice: data?.notice,
              });
              // 성공: 안내하고 모달 닫기
              messageApi.info('운동을 등록하였습니다.');
              setTimeout(() => {
                setState((prev) => ({ ...prev, reload: true }));
                setGModal((prev) => ({ ...prev, show: false }));
              }, 800);
            } catch (e) {
              // 에러가 발생하면, 상태코드로 분기
              if (e?.response?.status === 409) {
                // 유니크 중복 에러
                messageApi.error('이미 동일한 이름/카테고리의 운동이 존재합니다.');
              } else {
                // 기타 에러
                messageApi.error(
                  `[Error] ${e?.response?.data?.message || '운동을 등록하는데 실패하였습니다.'}`
                );
              }
            }
          }}
        >
          {'추가'}
        </Button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    width: '112rem',
    height: '100%',
    flexDirection: 'column',
    background: '#FFFFFF',
    boxshadow: '0px 5px 20px rgba(75, 70, 92, 0.4)',
    borderRadius: 6,
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
  },
  header: {
    display: 'flex',
    padding: '20px 24px',
    height: '6.4rem',
    background: 'rgba(168, 170, 174, 0.16)',
    border: 0,
    fontWeight: 600,
    fontSize: '1.8rem',
    lineHeight: '2.4rem',
  },
  footer: {
    display: 'flex',
    height: '5.8rem',
    justifyContent: 'flex-end',
    padding: '0px 24px 20px',
    marginTop: '2.4rem',
  },
  row: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0rem 2.4rem 0rem 2.4rem',
    background: '#FFFFFF',
  },
  row2: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    padding: '0rem 2.4rem 0rem 2.4rem',
    background: '#FFFFFF',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: '#FFFFFF',
  },
  timeBox: {
    display: 'flex',
    width: '33.2rem',
    height: '4rem',
    border: '2px dashed #7367F0',
    borderRadius: 6,
    padding: 0,
  },
  videoBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '72rem',
    height: '40.5rem',
    flexDirection: 'row',
    background: '#FFFFFF',
    border: '2px solid #7367F0',
  },
  label: {
    height: '1.5rem',
    fontWeight: 400,
    fontSize: '1.3rem',
    lineHeight: '1.5rem',
  },
  upload_title: {
    display: 'flex',
    width: '14rem',
    fontWeight: 600,
    fontSize: '1.1rem',
    lineHeight: '1.7rem',
  },
  upload_hint: {
    display: 'flex',
    width: '18.5rem',
    fontWeight: 600,
    fontSize: '1.0rem',
    lineHeight: '1.6rem',
  },
};

export default CreateExerciseModal;
